import VehSel from '../VehSel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { VehiclesActionCreator, FrameworkActionCreator, MenusActionCreator, AppointmentActionCreator, AdditionalServicesActionCreator, WebOpsActionCreator, QuickTimesActionCreator, ROHistoryActionCreator, RepairOrdersActionCreator, CustomerActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
    vehiclePhoto: state.Vehicles.vehiclePhoto,
    name: state.Appointment.ApptCust.custFirstName,
    specData: state.Specs.specs,
    apptVehicle: state.Vehicles.vehicles,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    additionalServices: state.AdditionalServices,
    apptVin: state.Appointment.ApptVeh.vin,
    apptVeh: state.Appointment.ApptVeh,
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    showWeOwes: state.Specs.specs?.showWeOwes,
    showOEMRecall: state.Specs.specs?.showOEMRecall,
    showPrvRecom: state.Specs.specs?.showPrvRecom,
    custMode: state.Framework.custMode,
    roHistory: state.ROHistory.allRoHistory,
    appointment: state.Appointment.Appointment,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    vehPhotoList: state.Vehicles.vehPhotoList,
    menusReturnCode: state.Menus.allMenus.returnCode,
    theme: state.Framework.theme,
    waitOnRecall: state.Framework.waitOnRecall,
    noAutoRecall: state.Framework.noAutoRecall,
    newVehicleMileage: state.NewVehicle.NewVehicle?.estMileage!,
    custInfo: state.Customer!['Customer'],
    sameFirstNames: state.Customer.sameFirstNames ?? false,
    multipleCustomers: state.Customer.multipleCustomers ?? false,
    identityVerified: state.Customer.identityVerified,
    verifyingIdentity: state.Customer.verifyingIdentity,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    locale: state.Framework.locale,
    viewVehicles: state.Framework.viewVehicles,
    previewFlag: state.Framework.previewFlag,
    vehErrMsg: state.Vehicles.errMsg,
    profileNum: state.Framework.specProfile,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    specDeptData: state.Specs.specs?.svcSpecs,
    loading: state.Customer.loading,
    apptCust: state.Appointment.ApptCust,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
    Itype: state.Framework.ImageServerType,
    vehiclesBuilt: state.Vehicles.vehiclesBuilt,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    vehSelReset: state.Framework.vehSelReset,
    settingHistId: state.Appointment.settingHistId,
});

const mapDispatchToProps = {
    getVehicles: VehiclesActionCreator.GetVehicles,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    getMenus: MenusActionCreator.GetMenus,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    updateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
    changeMileage: VehiclesActionCreator.ChangeMileage,
    getApptOps: WebOpsActionCreator.GetApptOps,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    getQuickTimes: QuickTimesActionCreator.GetQuickTimes,
    getROHistory: ROHistoryActionCreator.GetROHistory,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    determineDept: AppointmentActionCreator.DetermineDept,
    selectRO: RepairOrdersActionCreator.SelectRO,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    clearMenusState: MenusActionCreator.ClearMenusState,
    getRecalls: AdditionalServicesActionCreator.GetRecalls,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    searchCust: AppointmentActionCreator.SearchCust,
    getExCust: CustomerActionCreator.GetExCust,
    clearError: CustomerActionCreator.clearError,
    updateMaskedFields: AppointmentActionCreator.UpdateMaskedFields,
    checkAuthToken: CustomerActionCreator.CheckAuthToken,
    createVehicle: VehiclesActionCreator.CreateVehicle,
    custSearch: CustomerActionCreator.CustomerSearch,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    clearVehError: VehiclesActionCreator.VehiclesClearError,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    setNoAutoRecall: FrameworkActionCreator.SetNoAutoRecall,
    updateApptOps: AppointmentActionCreator.UpdateApptOps,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
    setApptHistId: AppointmentActionCreator.SetApptHistId,
    setVehSelReset: FrameworkActionCreator.SetVehSelReset,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VehSel);